import { createSlice } from "@reduxjs/toolkit";
import { 
    getDeliveryList, 
    getDeliveryManOrderList,
    updateOrderStatusByDeliveryMan // ✅ NEW import
} from "./ThunkActions";
import { iDeliveryState, REDUCER_NAME } from "./Type";

// Define initial state based on the provided structure
const initialState: iDeliveryState = {
    isLoading: false,
    deliveryManList: [],
    deliveryManOrderList: [],  
    errorMessage: null,
};

export const deliveryManSlice = createSlice({
    name: REDUCER_NAME,
    initialState,
    reducers: {
        resetDeliveryManState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            /* ---------------- GET DELIVERY MAN LIST ---------------- */
            .addCase(getDeliveryList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDeliveryList.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload?.data) {
                    state.deliveryManList = payload.data.data;
                }
                state.isLoading = false;
            })
            .addCase(getDeliveryList.rejected, (state) => {
                state.errorMessage = "Failed to fetch delivery man list";
                state.isLoading = false;
            })
            
            /* -------------- GET DELIVERY MAN ORDER LIST -------------- */
            .addCase(getDeliveryManOrderList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDeliveryManOrderList.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload?.data?.data) {
                    state.deliveryManOrderList = payload.data.data;   // ⭐ storing response
                }
                state.isLoading = false;
            })
            .addCase(getDeliveryManOrderList.rejected, (state, action) => {
                // @ts-expect-error
                state.errorMessage = action.payload?.message ?? "Failed to fetch delivery man order list";
                state.isLoading = false;
            })
            
            /* ✅ NEW: UPDATE ORDER STATUS BY DELIVERY MAN */
            .addCase(updateOrderStatusByDeliveryMan.pending, (state) => {
                state.isLoading = true;
                state.errorMessage = null;
            })
           .addCase(updateOrderStatusByDeliveryMan.fulfilled, (state, action) => {
    const payload = action.payload;

    // 🔹 Extract sent values (safe even if backend returns nothing)
    const updatedStatus = payload?.data?.status || action.meta.arg.status;
    const updatedOrderItemId = action.meta.arg.orderId;

    if (state.deliveryManOrderList?.length) {
        state.deliveryManOrderList = state.deliveryManOrderList.map((order: any) =>
            order.orderItemId === updatedOrderItemId
                ? { ...order, status: updatedStatus }
                : order
        );
    }

    state.isLoading = false;
    state.errorMessage = null;
})

            .addCase(updateOrderStatusByDeliveryMan.rejected, (state, action) => {
                //@ts-ignore
                state.errorMessage = action.payload?.message ?? "Failed to update order status";
                state.isLoading = false;
            });
    }
});

export const { resetDeliveryManState } = deliveryManSlice.actions;
export default deliveryManSlice.reducer;